module.exports = __webpack_public_path__ + "resources/icon_32_delete.1f75b999a53cd1c6.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_delete.png
// module id = 447
// module chunks = 0 1 2 3 4